import React from 'react';
import { CheckCircle2, AlertTriangle, User } from 'lucide-react';

export const TourMockBrief: React.FC = () => {
  return (
    <div className="w-full bg-white rounded-xl border border-border shadow-lg overflow-hidden aspect-video flex flex-col">
      <div className="h-1 w-full bg-gradient-to-r from-primary to-accent"></div>
      
      <div className="p-5 flex-1 overflow-hidden">
        <h3 className="font-display font-bold text-lg text-ink mb-4">Brief Gerado</h3>
        
        <div className="space-y-3">
          <div className="flex gap-3 p-3 rounded-lg border border-green-100 bg-green-50/50">
            <div className="mt-0.5 text-green-600"><CheckCircle2 size={16} /></div>
            <div>
              <div className="text-xs font-bold text-green-800 uppercase tracking-wide mb-0.5">Decisão</div>
              <div className="text-sm text-ink font-medium">Aprovação do orçamento até Sexta-feira</div>
            </div>
          </div>

          <div className="flex gap-3 p-3 rounded-lg border border-blue-100 bg-blue-50/50">
            <div className="mt-0.5 text-blue-600"><User size={16} /></div>
            <div>
              <div className="text-xs font-bold text-blue-800 uppercase tracking-wide mb-0.5">Ação • Carlos</div>
              <div className="text-sm text-ink font-medium">Atualizar deck de vendas</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};